"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  colors: {
    black: '#000000',
    blue: '#177AD0',
    blueLight: '#EDF3FA',
    gray: '#767676',
    grayLight: '#D6D6D6',
    purple: '#9C48B3',
    white: '#FFFFFF'
  },
  fonts: {
    gdsage: "gd-sage, 'Times New Roman', serif"
  }
};
exports.default = _default;